import React from 'react';
import LoadingType from "../../Models/LoadingType";
import {Spinner} from "reactstrap";

interface IProps {
  visible?: boolean;
  loading?: LoadingType
}

const LoadingComponent = ({ visible = true, loading }: IProps ) => {

  if ( loading ) visible = false;

  return (
    <>
      {
        (loading?.isLoading() || visible) &&
        <div className="d-flex justify-content-center">
          <Spinner className="mr-3" style={{width: '1.2rem', height: '1.2rem'}} type="grow"/>
          <Spinner className="mr-3" style={{width: '1.2rem', height: '1.2rem'}} type="grow"/>
          <Spinner style={{width: '1.2rem', height: '1.2rem'}} type="grow"/>
        </div>
      }
    </>
  );
};
export default LoadingComponent;
